<div class="asset-chip">
  <span
    >{{ asset.title }}
    @if (showLocation || showSite) {
      <span>(</span>
    }
    @if (showSite) {
      <span>
        {{ asset.siteTitle }}
        @if (showLocation) {
          <span>, </span>
        }
      </span>
    }
    @if (showLocation) {
      <span>{{ asset.location }}</span>
    }
    @if (showLocation || showSite) {
      <span>)</span>
    }
  </span>

  <div class="overlay-container">
    <!--
    <p-popover #assetop (mouseleave)="assetop.hide()">
      <div class="row">
        <div class="col-md-7 map">
    
          @if (gateway) {
            <img src="https://maps.googleapis.com/maps/api/staticmap?zoom=6&center={{ gateway.lat }},{{ gateway.lng }}&size=310x310&key=AIzaSyAB0LPDOu0ffDGhQyr9mzEDclU6Z39S7xM&markers=color:blue|{{ gateway.lat }},{{ gateway.lng }}" class="img-responsive" />
          }
        </div>

        <div class="col-md-5 gateway">
          @if (!gateway) {
            <i class="fa fa-refresh fa-spin"></i>
          }
          @if (gateway) {
            <div class="row">
              <div class="col-md-4 title">Asset id</div>
              <div class="col-md-8">
                {{ asset.id }}
              </div>
            </div>
          }
          @if (gateway) {
            <div class="row">
              <div class="col-md-4 title">Gateway#</div>
              <div class="col-md-8">
                {{ asset.gateway_id }}
              </div>
              <div class="col-md-4 title">Title</div>
              <div class="col-md-8">
                {{ gateway.title }}
              </div>
              <div class="col-md-4 title">Updated</div>
              <div class="col-md-8"><app-date [date]="asset.updatedAt" [showTime]="true"></app-date>&nbsp;</div>
              @if (gateway) {
                <div>
                  <div class="col-md-4 title">Status</div>
                  <div title="Status id:{{ gateway.statusId }}" class="col-md-8">
                    {{ gateway.statusTitle }}
                  </div>
                  <div class="col-md-4 title">Weather</div>
                  <div title="{{ gateway.localWeatherDate }}" class="col-md-8">{{ gateway.localWeatherTemp }}c</div>
                </div>
              }
            </div>
          }
        </div>

        <div class="col-md-5 site">
          @if (!site) {
            <i class="fa fa-refresh fa-spin"></i>
          }
          @if (site) {
            <div class="row">
              <div class="col-md-12" title="Site id:{{ site.id }}">
                <div><i class="fa fa-map-marker fa-fw"></i> {{ site.title }}</div>
                <div title="Address"><i class="fa fa-fw"></i> {{ site.address1 }}</div>
                <div><i class="fa fa-fw"></i> {{ site.address2 }}</div>
                <div><i class="fa fa-fw"></i> {{ site.address3 }}</div>
                <div><i class="fa fa-fw"></i> {{ site.addressTown }}</div>
                <div><i class="fa fa-fw"></i> {{ site.addressCounty }}</div>
                <div><i class="fa fa-fw"></i> {{ site.addressPostcode }}</div>
              </div>
              <div class="col-md-12"><i class="fa fa-phone-square fa-fw"></i> {{ site.addressTel }}</div>
              <div class="col-md-12"><i class="fa fa-envelope fa-fw"></i> {{ site.addressEmail }}</div>
            </div>
          }
        </div>

        <div class="col-md-12 sampling">
          @for (item of charts; track item; let i = $index) {
            <div class="row chart-row">
              @if (asset.assetType !== apiService.ASSET_TYPES_BY_TITLE.WIFI) {
                <div class="col-md-12">
                  @if (data.datasets[i].data.length) {
                    <p-chart name="chart" #chart type="bar" [data]="data" [options]="options"></p-chart>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </p-popover>
  --></div>
</div>
